export enum ValidationMessageKeys {
  required = 'validation.error-message.required',
  max = 'validation.error-message.max',
  min = 'validation.error-message.min',
  arrayMin = 'validation.error-message.array-min',
  arrayMax = 'validation.error-message.array-max',
  lengthMax = 'validation.error-message.length-max',
  lengthMin = 'validation.error-message.length-min',
  tooLong = 'validation.error-message.too-long',
  tooShort = 'validation.error-message.too-short',
  integer = 'validation.error-message.is-not-an-integer',
  number = 'validation.error-message.is-not-number',
  format = 'validation.error-message.invalid-format',
  onlyDigits = 'validation.error-message.only-digits-allowed',
  phoneFormat = 'validation.error-message.invalid-phone-number',
  sapCustomerErrorKey = 'validation.error-message.invalid-sap-customer',
  sapCustomerNotUniqueErrorKey = 'validation.error-message.duplicate-sap-customer',
  minDate = 'validation.error-message.before-min-date',
  maxDate = 'validation.error-message.after-max-date',
  timeFormat = 'validation.error-message.invalid-time-format',
  hoursFormat = 'validation.error-message.invalid-hours-format',
  emailFormat = 'validation.error-message.invalid-email-format',
}
